import { MapPin, Phone, Mail, Facebook, Instagram } from "lucide-react";
import { Link } from "react-router-dom";
import logo from "@/assets/logowhite.png";

const Footer = () => {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer className="bg-primary text-white pt-16 pb-8">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-2 gap-12 mb-12 md:items-start">
          {/* Info Azienda */}
          <div>
            <div className="flex items-start gap-3 mb-6">
              <img src={logo} alt="Mangimi Rubini" className="h-16 md:h-20 w-auto" />
              <div>
                <h3 className="text-2xl font-heading font-bold text-white mb-2">MANGIMI RUBINI</h3>
                <p className="text-white/80 text-sm">
                  Dal 1983, grazie a Pietro e Napoleone prima e Manuel e Alessio dopo, Rubini continua a servire i clienti con passione ed esperienza
                </p>
              </div>
            </div>
            <div className="space-y-2 text-white/80">
              <div className="flex items-start gap-2">
                <MapPin className="w-5 h-5 flex-shrink-0 mt-0.5" />
                <div>
                  <p>Viale Umbria 21</p>
                  <p>06063 Magione (PG)</p>
                </div>
              </div>
            </div>
          </div>

          {/* Contatti e Social */}
          <div className="md:pt-0">
            <h4 className="font-heading font-semibold text-lg mb-4">Contatti</h4>
            <div className="space-y-3 mb-6">
              <a
                href="tel:+393466257639"
                className="flex items-center gap-2 text-white/80 hover:text-white transition-colors"
              >
                <Phone className="w-5 h-5" />
                <span>+39 346 625 7639</span>
              </a>
              <a
                href="mailto:mangimirubini@gmail.com"
                className="flex items-center gap-2 text-white/80 hover:text-white transition-colors"
              >
                <Mail className="w-5 h-5" />
                <span>mangimirubini@gmail.com</span>
              </a>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-lg mb-4">Seguici</h4>
              <div className="flex gap-4">
                <a
                  href="#"
                  className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors"
                  aria-label="Facebook"
                >
                  <Facebook className="w-5 h-5" />
                </a>
                <a
                  href="https://www.instagram.com/rubini_mangimi_e_garden/?hl=it"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors"
                  aria-label="Instagram"
                >
                  <Instagram className="w-5 h-5" />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="pt-8 border-t border-white/20">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-center md:text-left text-white/60 text-sm">
              © 2025 Mangimi Rubini - P.IVA: xxxxxxxx - Tutti i diritti riservati
            </p>
            <div className="flex gap-4 text-sm">
              <Link to="/privacy-policy" className="text-white/60 hover:text-white transition-colors">
                Privacy Policy
              </Link>
              <span className="text-white/40">|</span>
              <Link to="/cookie-policy" className="text-white/60 hover:text-white transition-colors">
                Cookie Policy
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
